<!-- Table -->
<div class="table-responsive">
  <table class="table table-borderless table-hover">
    <thead class="table-light">
      <tr>
        <th scope="col">{{ 'competitionModule.position' | translate }}</th>
        <th scope="col">{{ 'competitionModule.team' | translate }}</th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.played' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.playedAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.wins' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.winAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.draw' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.drawAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.lost' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.lostAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.goalsScored' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.goalsScoredAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.goalsAgainst' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.goalsAgainstAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.goalDifference' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.goalDifferenceAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.penalties' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.penaltiesAbbreviation' | translate }}
        </th>
        <th
          tabindex="0"
          scope="col"
          [tooltip]="'competitionModule.points' | translate"
          [adaptivePosition]="false"
          container="body"
        >
          {{ 'competitionModule.pointsAbbreviation' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let result of competitionStandings$ | async">
        <td>
          <strong>{{ result.position }} </strong>
        </td>
        <td>
          {{ result.teamName }}
        </td>
        <td>{{ result.gamesPlayed }}</td>
        <td>{{ result.wins }}</td>
        <td>{{ result.draws }}</td>
        <td>{{ result.losses }}</td>
        <td>{{ result.goalsFor }}</td>
        <td>{{ result.goalsAgainst }}</td>
        <td>{{ result.goalDifference }}</td>
        <td>{{ result.penalties ? result.penalties : 0 }}</td>
        <td>{{ result.points }}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- End Table -->
